export default {
  'createBill.purchaseorderno': 'Заказ на покупку №:',
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088':
    'Филиал Ирана, №18, Алванд Билдинг, Алванд ул.Argentina Sq., Tehran, Iran.	Аргентина пл., Тегеран, Иран.Phone: +98 21 88663088`, Телефон: +98 21 88663088',
  'createBill.date': 'Дата',
  'createBill.supplieraddress': 'Адрес поставщика:',
  'createBill.3061valiasrsttehraniran': '# 3061, Valiasr St,, Тегеран, Иран',
  'createBill.requestername': 'Имя запрашивающего',
  'createBill.paymentterms': 'Условия оплаты',
  'createBill.frominvoicereceipt': 'от получения счета',
  'createBill.projectname': 'Название проекта:',
  'createBill.test': 'Тест',
  'createBill.pos': 'POS',
  'createBill.description': 'Описание',
  'createBill.quantity': 'Количество',
  'createBill.uom': 'UOM',
  'createBill.netprice': 'Цена нетто',
  'createBill.per': 'По',
  'createBill.totalprice': 'Итоговая цена',
  'createBill.curr': 'валюта',
  'createBill.deliverydate': 'Дата доставки',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - High Quality - Wireless',
  'createBill.totalgrossamount': 'ОБЩАЯ СУММА ВЕСА(включая налог, если есть)',
  'createBill.months': 'месяц',
  'createBill.hours': 'Час',
  'createBill.days': 'День',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma Service AG',
};
